/**
 * TanStack Router: /performance/avaliacoes-individuais
 *
 * This route file was auto-generated by the route generation script.
 * Component: AvaliacoesIndividuaisPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import AvaliacoesIndividuaisPage from '@/app/performance/avaliacoes-individuais/page'

/**
 * Route: /performance/avaliacoes-individuais
 * Layout: _auth (authenticated)
 * Component: AvaliacoesIndividuaisPage
 */
export const Route = createFileRoute('/_auth/performance/avaliacoes-individuais/')({
  component: AvaliacoesIndividuaisPage,
})
